import React from "react";

/**
 * Premium grouped section for long forms.
 * - Numbered eyebrow + serif title + optional hint.
 * - Children render in a normal grid; supply your own .rfq-grid-* inside.
 */
export function FormSection({ index, title, hint, children, testId }) {
  return (
    <section className="form-section" data-testid={testId}>
      <header className="form-section-head">
        {typeof index === "number" && (
          <span className="form-section-num font-mono" aria-hidden>
            {String(index).padStart(2, "0")}
          </span>
        )}
        <div className="form-section-text">
          <h3 className="font-serif-display form-section-title">{title}</h3>
          {hint && <p className="form-section-hint">{hint}</p>}
        </div>
      </header>
      <div className="form-section-body">{children}</div>
    </section>
  );
}

export default FormSection;
